import { QueryHookOptions, useQuery } from '@apollo/client';
import query from '../../queries/referrer';
import { Referrer } from 'generated-types/graphql';

interface UseReferrerRequest{
  referralCode: string;
}

interface UseReferrerResponse{
  referrer: Referrer;
}

export default function useReferrer(
  referralCode: string,
  options: QueryHookOptions<UseReferrerResponse, UseReferrerRequest> = {}
) {
  const { data, ...rest } = useQuery<
  UseReferrerResponse,
    UseReferrerRequest
  >(query, {
    ...options,
    variables: {
      referralCode
    }
  });

  const referrer = data?.referrer;

  return {
    referrer,
    ...rest
  };
}
